import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { EMPTY, Subscription } from 'rxjs';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-contexts-contexts-dashboard',
  templateUrl: './contexts-contexts-dashboard.component.html',
  styleUrls: ['./contexts-contexts-dashboard.component.scss']
})
export class ContextsContextsDashboardComponent implements OnInit, OnDestroy {

  contexts;
  filterOpts;
  filterKey;
  noItemsConfig;
  viewDisposition = 'grid';
  getContextsSubscription: Subscription;
  searchContextsSubscription: Subscription;
  filterContextsSubscription: Subscription;
  getContextsSubscriptionRefresh: Subscription;
  toggleContextsDispositionSubscription: Subscription;

  constructor(private contextsService: ContextsContextsService,
    private snackbarService: SnackBarService,
    private cd: ChangeDetectorRef,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.setBreadcrumb();
    this.getContexts();
    this.getContextsSubscriptionRefresh = this.contextsService.refreshContextsListen().pipe(
      tap(o =>  this.getContexts())
    ).subscribe();
    this.filterContextsSubscription = this.contextsService.filterContextsListen().pipe(
      tap(o => this.filterOpts = o),
      tap(o => this.cd.detectChanges())
    ).subscribe();
    this.searchContextsSubscription = this.contextsService.searchContextsListen().pipe(
      tap(o => this.filterKey = o)
    ).subscribe();
    this.toggleContextsDispositionSubscription = this.contextsService.toggleContextsDispositionListen().pipe(
      tap(o => this.viewDisposition = o)
    ).subscribe();
  }

  private getContexts() {
    this.getContextsSubscription = this.contextsService.getContexts().pipe(
      tap(o => this.contexts = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-hdd', 'apisecrets-page.apisecrets', '/account', [new BRoute('account-page.account', '/account'), new BRoute('apisecrets-page.apisecrets')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'apisecrets-page.apisecrets not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getContextsSubscription) { this.getContextsSubscription.unsubscribe(); }
    if (this.searchContextsSubscription) { this.searchContextsSubscription.unsubscribe(); }
    if (this.filterContextsSubscription) { this.filterContextsSubscription.unsubscribe(); }
    if (this.getContextsSubscriptionRefresh) { this.getContextsSubscriptionRefresh.unsubscribe(); }
    if (this.toggleContextsDispositionSubscription) { this.toggleContextsDispositionSubscription.unsubscribe(); }
  }
}
